import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';

import { useContactInfo } from 'reservations/account/providers/ConfigProvider';
import { useModal } from 'reservations/base/providers/ModalProvider';
import { MEDIUM_TOFU, SOY, WHITE } from 'reservations/brand/constants';

export const GetHelpDrawer = () => {
  const { isOpen, close } = useModal();
  const { phoneNumber, emailAddress, hasEmailAddress, hasPhoneNumber } =
    useContactInfo();
  return (
    <Drawer
      anchor="bottom"
      open={isOpen}
      onClose={close}
      PaperProps={{
        sx: {
          backgroundColor: 'transparent'
        }
      }}
    >
      <Box
        sx={{ width: 'auto' }}
        role="presentation"
        data-testid="contact-list"
      >
        <List sx={{ paddingBottom: 0 }}>
          {hasPhoneNumber && (
            <ListItem disablePadding sx={{ backgroundColor: `${SOY}B3` }}>
              <ListItemButton>
                <ListItemIcon>
                  <PhoneIcon sx={{ color: MEDIUM_TOFU }} />
                </ListItemIcon>
                <Typography
                  data-testid="phone-link"
                  component="a"
                  href={`tel:${phoneNumber}`}
                  sx={{
                    textDecoration: 'none',
                    fontSize: '20px',
                    color: WHITE,
                    textTransform: 'none'
                  }}
                >
                  Call {phoneNumber}
                </Typography>
              </ListItemButton>
            </ListItem>
          )}
          {hasPhoneNumber && hasEmailAddress && <Divider />}
          {hasEmailAddress && (
            <ListItem disablePadding sx={{ backgroundColor: `${SOY}B3` }}>
              <ListItemButton>
                <ListItemIcon>
                  <MailIcon sx={{ color: MEDIUM_TOFU }} />
                </ListItemIcon>
                <Typography
                  data-testid="mail-link"
                  component="a"
                  href={`mailto:${emailAddress}`}
                  sx={{
                    textDecoration: 'none',
                    fontSize: '20px',
                    color: WHITE,
                    textTransform: 'none'
                  }}
                >
                  Email {emailAddress}
                </Typography>
              </ListItemButton>
            </ListItem>
          )}
          <Divider />
          <ListItem disablePadding sx={{ backgroundColor: SOY }}>
            <ListItemButton
              onClick={close}
              sx={{ display: 'grid', justifyContent: 'center' }}
              data-testid="close-contact-modal"
            >
              <Typography
                sx={{ fontSize: '20px', color: WHITE, textTransform: 'none' }}
              >
                Cancel
              </Typography>
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
};
